const Name = (props) => {
  const { customer } = props;
  if (!customer.firstName || !customer.lastName) {
    return null;
  }
  return (
    <>
      {customer.firstName} {customer.lastName}
    </>
  );
};
export default Name;
